import React, { FC } from 'react'
import useViewContext from '@modules/order/hooks/use-view-context'
import { ListUIStore } from '@modules/order/stores/view/List/ListUIStore'
import * as css from './QuantityHeaderWithKPI.css'
import classNames from 'classnames'
import useOrderContext from '@modules/order/hooks/use-order-context'
import { useTranslation } from 'react-i18next'

export interface CellProps {
  header?: any
  doorOrderId?: string
}

const QuantityKPICell: FC<CellProps> = ({ header, doorOrderId }) => {
  const { t } = useTranslation()
  const viewContextVal = useViewContext()
  const store = viewContextVal.uiStore as ListUIStore
  const { getHeaderDoorKpis } = store
  const {
    uiStore: {
      quantityTypeStore: { type }
    }
  } = useOrderContext()
  const doorKpi = doorOrderId ? getHeaderDoorKpis(doorOrderId, type) : null
  return (
    <>
      <div className={classNames(css.cellWrapper, css['cell-border'])}>
        <span
          className={css.cell}
          style={{ fontWeight: doorKpi?.[header.field] ? 'normal' : 500 }}
        >
          {doorKpi?.[header.field] ??
            t(`order.otbHeaders.label.${header.key}`, header.label)}
        </span>
      </div>
    </>
  )
}

export default QuantityKPICell
